import React from 'react';

const LoadingSpinner: React.FC = () => {
  return (
    <div className="w-16 h-16 border-8 border-t-BAMPink border-r-transparent border-b-BAMBlue border-l-transparent rounded-full animate-spin"></div>
  );
};

export default LoadingSpinner;